/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import {
  InputV2,
  DefaultSelectV2,
  NumberInputV2,
  TrueFalseSelectV2,
  ArquivoContainerV2,
  DatePickerV2,
  OptionSelectV2,
} from '../../../components/v2';

const InformacaoBasicaTab = ({ values, setValues, errors, handleChange }) => (
  <Grid container spacing={1} sx={{ mt: 0 }}>
    <Grid size={{ xs: 12, sm: 3 }}>
      <DefaultSelectV2
        error={!!(errors && errors.categoria)}
        isRequired
        label="Categoria"
        name="categoria"
        showEmpty
        options={[
          { id: 'BICICLETA_ELETRICA', nome: 'Bicicleta Elétrica' },
          { id: 'CARRO', nome: 'Carro' },
          { id: 'CAMINHAO', nome: 'Caminhão' },
          { id: 'UTILITARIO_CAMINHONETE', nome: 'Caminhonete' },
          { id: 'MAQUINA', nome: 'Máquina' },
          { id: 'MOTO', nome: 'Moto' },
          { id: 'REBOQUE', nome: 'Reboque' },
        ]}
        onSelect={handleChange}
        value={values.categoria}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        error={!!(errors && errors.placa)}
        helperText={errors && errors.placa ? errors.placa[0] : null}
        isRequired
        label="Placa"
        name="placa"
        onChange={handleChange}
        placeholder="Placa"
        value={values.placa || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Num. Frota"
        name="numFrota"
        onChange={handleChange}
        placeholder="numFrota"
        value={values.numFrota || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.ativo)}
        isRequired
        label="Ativo"
        name="ativo"
        onChange={handleChange}
        value={values.ativo}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <DefaultSelectV2
        error={!!(errors && errors.tipoVeiculo)}
        isRequired
        label="Proprietário"
        name="tipoVeiculo"
        showEmpty
        options={[
          { id: 'ELETROPONTES', nome: 'Eletropontes' },
          { id: 'PARTICULAR', nome: 'Particular' },
          { id: 'ALUGADO', nome: 'Alugado' },
        ]}
        onSelect={(event) => {
          setValues({
            ...values,
            [event.target.name]: event.target.value,
            valorAquisicao: undefined,
            dataAquisicao: undefined,
            transferido: undefined,
            dataTransferencia: undefined,
          });
        }}
        value={values.tipoVeiculo}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <OptionSelectV2
        label="Finalidades"
        codigo="VEICULO_FINALIDADES"
        onSelect={(finalidade) => setValues({
          ...values,
          finalidade,
        })}
        value={values.finalidade}
      />
    </Grid>
    {values.id && (
      <>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2 label="Criado Por" disabled value={values.criadoPorName || ''} />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2 label="Data Inclusão" disabled value={values.dataInclusao || ''} />
        </Grid>
      </>
    )}
    <Grid size={{ xs: 12, sm: 3 }}>
      <NumberInputV2
        prefix="R$ "
        label="Valor da Aquisição"
        name="valorAquisicao"
        isRequired={values.tipoVeiculo === 'ELETROPONTES'}
        disabled={values.tipoVeiculo !== 'ELETROPONTES'}
        onChange={(valor) => setValues({
          ...values,
          valorAquisicao: valor,
        })}
        value={values.valorAquisicao || undefined}
        decimalScale={2}
        numericValue
        fixedDecimalScale
        error={!!(errors && errors.valorAquisicao)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <DatePickerV2
        label="Data da Aquisição"
        isRequired={values.tipoVeiculo === 'ELETROPONTES'}
        disabled={values.tipoVeiculo !== 'ELETROPONTES'}
        error={!!(errors && errors.dataAquisicao)}
        onChange={(data) => setValues({
          ...values,
          dataAquisicao: data,
        })}
        value={values.dataAquisicao}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.transferido)}
        isRequired={values.tipoVeiculo === 'ELETROPONTES'}
        disabled={values.tipoVeiculo !== 'ELETROPONTES'}
        label="CRV Transferido"
        name="transferido"
        onChange={handleChange}
        value={values.transferido || undefined}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <DatePickerV2
        label="Data da Transferência"
        isRequired={values.tipoVeiculo === 'ELETROPONTES' && values.transferido === 'true'}
        disabled={
          values.tipoVeiculo !== 'ELETROPONTES'
          || (values.transferido !== 'true' && values.transferido !== true)
        }
        error={!!(errors && errors.dataTransferencia)}
        onChange={(data) => setValues({
          ...values,
          dataTransferencia: data,
        })}
        value={values.dataTransferencia}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <NumberInputV2
        prefix=""
        label="Km Inicial"
        name="kmInicial"
        onChange={(kmInicial) => setValues({
          ...values,
          kmInicial,
        })}
        value={values.kmInicial}
        decimalScale={0}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        disabled
        label="Km Atual"
        name="kmAtual"
        onChange={handleChange}
        value={values.kmAtual || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Modelo"
        name="modelo"
        onChange={handleChange}
        value={values.modelo || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Ano Modelo"
        name="ano"
        onChange={handleChange}
        value={values.ano || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Fabricante"
        name="fabricante"
        onChange={handleChange}
        value={values.fabricante || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Ano Fabricação"
        name="anoFabricacao"
        onChange={handleChange}
        value={values.anoFabricacao || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Cor"
        name="cor"
        onChange={handleChange}
        value={values.cor || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="CRLV"
        name="crlv"
        onChange={handleChange}
        value={values.crlv || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Chassi"
        name="chasi"
        onChange={handleChange}
        value={values.chasi || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Renavam"
        name="renavam"
        onChange={handleChange}
        value={values.renavam || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Tipo"
        name="tipo"
        onChange={handleChange}
        value={values.tipo || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Combustível"
        name="combustivel"
        onChange={handleChange}
        value={values.combustivel || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.possuiRastreador)}
        isRequired
        label="Possui Rastreador"
        name="possuiRastreador"
        onChange={handleChange}
        value={values.possuiRastreador}
      />
    </Grid>
    {(values.possuiRastreador === 'true' || values.possuiRastreador === true) && (
      <>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            error={!!(errors && errors.numRastreador)}
            isRequired
            label="Num. Rastreador"
            name="numRastreador"
            onChange={handleChange}
            value={values.numRastreador || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Fornecedor Rastreador"
            name="fornecedorRastreador"
            onChange={handleChange}
            value={values.fornecedorRastreador || ''}
          />
        </Grid>
      </>
    )}
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.possuiCamera)}
        isRequired
        label="Possui Camera"
        name="possuiCamera"
        onChange={handleChange}
        value={values.possuiCamera}
      />
    </Grid>
    {(values.possuiCamera === 'true' || values.possuiCamera === true) && (
      <Grid size={{ xs: 12, sm: 3 }}>
        <InputV2
          error={!!(errors && errors.numCamera)}
          isRequired
          label="Num. Camera"
          name="numCamera"
          onChange={handleChange}
          value={values.numCamera || ''}
        />
      </Grid>
    )}
    {values.id && (
      <Grid size={{ xs: 12, sm: 6 }}>
        <InputV2
          disabled
          label="Último repasse"
          value={values.ultimoRepasse || ''}
        />
      </Grid>
    )}
    <Grid size={{ xs: 12 }}>
      <InputV2
        label="Descrição"
        name="descricao"
        onChange={handleChange}
        value={values.descricao || ''}
        rows={3}
        multiline
      />
    </Grid>
    <Grid size={{ xs: 12 }}>
      <ArquivoContainerV2
        arquivos={values.arquivos}
        onSave={(arquivos) => setValues({ ...values, arquivos })}
      />
    </Grid>
  </Grid>
);

InformacaoBasicaTab.propTypes = {
  id: PropTypes.string,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

export default InformacaoBasicaTab;
